import React from 'react';
import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import PushNotification from './push-notification';
import PushNotificationSettings from './push-notification-settings';
import PushNotificationSegments from './push-notification-segments';

function PushDashboard({ match }: InferProps<typeof PushDashboard.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:abbrv`} component={PushNotification} />
      <Route exact path={`${match.url}/:abbrv/settings`} component={PushNotificationSettings} />
      <Route exact path={`${match.url}/:abbrv/segments`} component={PushNotificationSegments} />
    </Switch>
  );
}

PushDashboard.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default PushDashboard;
